import React from 'react'
import Layout from '../components/layout'
import Styled from 'styled-components'
import { graphql } from 'gatsby';

export default ({ data }) => {
  const page = data.markdownRemark

  return (
    <Layout>
      <h1>{page.frontmatter.title}</h1>
      <InnerContent dangerouslySetInnerHTML={{ __html: page.html }} />
    </Layout>
  )
}

const InnerContent = Styled.div`
  > p:first-of-type {
    font-size: 1.1rem;
  }

  > h1, > h2, > h3, > h4, > h5, > h6 {
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;
    font-weight: 600;
  }


  > h2 {
    font-size: 1.6875rem;
    margin-bottom: 10px;
    margin-top: 65px;
    letter-spacing: .05px;
  }

  pre[class*="language-"] {
    padding: 20px 30px;
    background: #f9f9fb;
    box-shadow: inset 0 0 10px #e3e7ea, inset 0 0 2px #e3e7ea, 0 1px 0 0 #fff;
    margin: 0 0 40px;
    border-radius: 5px;
    text-shadow: 0 1px 0 #fff!important;
    border: 1px solid #e6e9ec;
  }

  pre[class*="language-"] code[class*="language-"] {
    font-family: Roboto Mono,monospace;
    font-size: 12px;
    padding-left: 0;
  }

  > blockquote {
    border: 1px solid #e6e9ec;
    padding: 12px 20px;
    border-radius: 5px;
    box-shadow: 0 3px 8px 0 rgba(0,0,0,.03);
    background-color: #fff;
    border-left: 3px solid #2d53fe;
    font-size: 13px;
    line-height: 1.5;

    > * {
      margin: 0;
      padding: 0;
    }
  }
`

export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
      }
    }
  }
`
